<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-xl-8">
          <navigation
            :list="lastFiveYears"
            :active-value="activeYear"
            variety="underline"
            @active:updated="updateActiveYear"
          />
        </div>
      </div>
      <div class="enterprise_visit_content_area row">
        <div
          v-if="visitsGetter.length"
          class="col-12"
        >
          <enterprise-visit-card
            v-for="visit in visitsGetter"
            :key="visit.visit_id"
            :enterprise-visit-id="visit.visit_id"
            :company="visit.visit_company"
            :start-time="visit.visit_start_date"
            :show-status="visit.visit_show_status"
            :students-count="visit.visit_students_count"
            :taker="visit.visit_taker"
          />
        </div>
        <div
          v-else
          class="col-12 text-center"
        >
          尚未舉辦企業參訪
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <bootstrap-pagination
            v-if="pageGetter.page_total > 1"
            :total-page-number="pageGetter.page_total"
            @number:updated="updateVisitPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { lastFiveYearsStartFrom2019, thisYearNumber } from '~utils/date-time'
import EnterpriseVisitCard from '~components/pages/enterprise-visits/EnterpriseVisitCard'
import BootstrapPagination from '~bootstrap/Pagination'
import Navigation from '~components/common/Navigation'

export default {
  name: 'EnterpriseVisitIndexContent',
  components: {
    EnterpriseVisitCard,
    BootstrapPagination,
    Navigation
  },
  data () {
    return {
      lastFiveYears: lastFiveYearsStartFrom2019(),
      activeYear: thisYearNumber
    }
  },
  computed: {
    ...mapGetters('pages/enterprise-visits', [
      'visitsGetter',
      'pageGetter'
    ])
  },
  async created () {
    await this.getVisitsAll({
      year: this.activeYear
    })
  },
  methods: {
    ...mapActions('pages/enterprise-visits', [
      'getVisitsAll'
    ]),
    updateVisitPage (page) {
      this.getVisitsAll({
        year: this.activeYear,
        page
      })
    },
    updateActiveYear (year) {
      if (year) {
        this.activeYear = year
        this.getVisitsAll({
          year: this.activeYear
        })
      }
    }
  }
}
</script>
